export default {"src":"/pro/_next/static/media/arca-logo.f2eee11c.svg","height":200,"width":700,"blurWidth":0,"blurHeight":0};